<div class="container-fluid">
  <div class="page-title in-breadcrumb">
    <div class="row">
      <div class="col-md-6 d-flex align-items-start align-items-md-center flex-column flex-md-row gap-2 mb-2">
        <h3>{{ title | translate }}</h3>

        <ng-container *ngIf="helperRoute">
          <a [href]="'/pages/helper/'+helperRoute" target="_blank" class=" d-flex gap-2" [ngClass]="{'flex-row-reverse': !isDirRTL}">
            <i class="pi pi-question-circle text-danger" style="font-size: 1.5rem"></i>
            <span class=" text-danger">{{isDirRTL ? 'طلب المساعدة' : 'Request Help'}}</span>
          </a>
        </ng-container>
      </div>
      <div class="col-md-6 d-flex justify-content-start justify-content-md-end">
        <ol class="breadcrumb">
          <li class="breadcrumb-item">
            <a [routerLink]="'/dashboard/default'">
              <svg class="stroke-icon">
                <use href="assets/svg/icon-sprite.svg#stroke-home"></use>
              </svg>
            </a>
          </li>
          <li class="breadcrumb-item" *ngFor="let item of items">{{ item | translate }}</li>
          <li class="breadcrumb-item active">{{ active_item | translate }}</li>
        </ol>
      </div>
    </div>
  </div>
</div>
